export default "__VITE_ASSET__4u33okxm__"